import axios from 'axios'
import Noty from 'noty'

var app = {
  state: {
    coin         : '',
    coinLogo     : '',
    coinName     : '',
    preCoin      : '',
    preCoinLogo  : '',
    isMemoCoin   : false,
    coins        : [],
    pageSelected : '',
    mode         : 'light',
    tiers        : [],
    coinCategories: [],
    showWarningMessage: true,
    warningMessageTime: 0,
    hintSwitchCoinTime: 0,
    addressHistory: [],
    lastAddresses: {},
    lastCoins: [],
    lastAlgorithms: [],
    coinSymbol: 'BTC', // set BTC as default
    coinData: {},
    version: '',
    lastNewsDate: 1669667290000,
    newsCount: 0,
    liveFilter: [],
    ref: '',
    lastAddressCoinFilters: [],
    showCoinSwitcher: false,
    chartPeriod: 1,
    logChart: true
  },
  mutations: {
    SET_NEWS_COUNT(state, params) {
      state.newsCount = params
    },
    SET_SHOW_COIN_SWITCHER(state, params) {
      state.showCoinSwitcher = params
    },
    SET_LAST_ADDRESSES_COIN_FILTER(state, params) {
      state.lastAddressCoinFilters = params
    },
    SET_REF(state, params) {
      state.ref = params
    },
    SET_LIVE_FILTER(state, params) {
      state.liveFilter = params
    },
    SET_LAST_NEWS_DATE(state, params) {
      state.lastNewsDate = params
    },
    SET_VERSION (state, params) {
      state.version = params
    },
    SET_LAST_ALGORITHMS (state, params) {
      state.lastAlgorithms = params
    },
    SET_COIN (state, params) {
      state.coin = params.coin
    },
    SET_COIN_SYMBOL (state, params) {
      state.coinSymbol = params
    },
    SET_COIN_DATA (state, params) {
      state.coinData = params
    },
    SET_COIN_LOGO (state, params) {
      state.coinLogo = params.coinLogo
    },
    SET_COIN_NAME (state, params) {
      state.coinName = params.coinName
    },
    SET_IS_MEMO_COIN (state, params) {
      state.isMemoCoin = !!params.regex_memo
    },
    SET_COINS (state, params) {
      state.coins = params.coins
    },
    SET_PAGE_SELECTED (state, page) {
      state.pageSelected = page
    },
    SET_MODE (state, mode) {
      state.mode = mode
    },
    SET_TIERS (state, params) {
      state.tiers = params.tiers
    },
    SET_PRE_COIN_SYMBOL(state, params) {
      state.preCoin = params
    },
    SET_PRE_COIN_LOGO(state, params) {
      state.preCoinLogo = params
    },
    SET_COIN_CATEGORIES (state, params) {
      state.coinCategories = params.coinCategories
    },
    SET_SHOW_WARNING_MESSAGE (state, params) {
      state.showWarningMessage = params
    },
    SET_HINT_SWITCH_COIN_TIME(state, params) {
      state.hintSwitchCoinTime = params
    },
    SET_WARNING_MESSAGE_TIME(state, params) {
      state.warningMessageTime = params
    },
    SET_ADDRESS_HISTORY(state, params) {
      state.addressHistory = params
    },
    SET_LAST_ADDRESSES(state, params) {
      state.lastAddresses = params
    },
    SET_LAST_COINS(state, params) {
      state.lastCoins = params
    },
    SET_CHART_PERIOD(state, params) {
      state.chartPeriod = params
    },
    SET_LOG_CHART(state, params) {
      state.logChart = params
    }
  },
  actions: {
    setNewsCount({ commit }, params) {
      commit('SET_NEWS_COUNT', params)
    },
    openCoinSwitcher({ commit, state }) {
      commit('SET_SHOW_COIN_SWITCHER', true)
    },
    closeCoinSwitcher({ commit, state }) {
      commit('SET_SHOW_COIN_SWITCHER', false)
    },
    clearLastAddressesCoinFilter({ commit, state }) {
      commit('SET_LAST_ADDRESSES_COIN_FILTER', [])
    },
    toggleLastAddressesCoinFilter({ commit, state }, coin) {
      let currentCoins = state.lastAddressCoinFilters;
      if (currentCoins.indexOf(coin) > -1) currentCoins.splice(currentCoins.indexOf(coin), 1)
      else currentCoins.push(coin)
      commit('SET_LAST_ADDRESSES_COIN_FILTER', currentCoins)
    },
    setRef({ commit }, params) {
      commit('SET_REF', params)
    },
    setLiveFilter({ commit }, params) {
      commit('SET_LIVE_FILTER', params)
    },
    setLastNewsDate({ commit }, params) {
      commit('SET_LAST_NEWS_DATE', params)
    },
    setVersion({ commit }, params) {
      commit('SET_VERSION', params)
    },
    setLastAlgorithms({ commit }, params) {
      commit('SET_LAST_ALGORITHMS', params)
    },
    setAddressHistory({ commit }, searchHistory) {
      // Reset the last address per coin
      let lastAddresses = {}
      for (let i = 0; i < searchHistory.length; i++) {
        lastAddresses[searchHistory[i].coin] = searchHistory[i].addresses[0]
      }
      commit('SET_LAST_ADDRESSES', lastAddresses)
      commit('SET_ADDRESS_HISTORY', searchHistory)
    },
    setLastCoins({ commit }, params) {
      commit('SET_LAST_COINS', params)
    },
    async validateVersion ({ commit, state }) {
      let localVersion = state.version
      if (!(localVersion && localVersion === process.env.VERSION)) {
        // Reset algorithm list order
        commit('SET_LAST_ALGORITHMS', [])
        commit('SET_VERSION', process.env.VERSION)
      }
      let url = 'https://api.unminable.com/v3/site/version'
      return axios.get(url).then(function (response) {
        if (response && response.data && response.data.success && response.data.data !== process.env.VERSION) {
          new Noty({
            text: 'There is a newer version of the website, please reload to get the latest update!',
            theme: 'relax',
            type: 'warning',
            layout: 'bottomCenter',
            timeout: false,
            progressBar: false,
            killer: true,
            template: '<div class="noty_message reload"><span class="noty_text"></span><div class="noty_close"></div></div>'
          }).show()
        }
      }).catch(function (error) {
        console.error('error:', error)
      });
    },
    async setCoin ({ commit }, params) {
      return await axios.get(`https://api.unminable.com/v5/coin/${params.coin}`).then(function (response) {
        commit('SET_COIN_SYMBOL', params.coin)
        commit('SET_COIN_DATA', {
          coin: response.data.data.symbol,
          name: response.data.data.name,
          logo: response.data.data.logo,
          regex_memo: response.data.data.regex_memo,
          address_prefix: response.data.data.address_prefix,
          high_risk: response.data.data.high_risk
        })
        commit('SET_COIN', params)
        commit('SET_COIN_LOGO', params)
        commit('SET_COIN_NAME', params)
        commit('SET_IS_MEMO_COIN', params)
      }).catch(function (error) {
        console.error('error.response', error.response)
        if (error.response && error.response.status === 404) {
          throw new Error('INVALID');
        } else {
          new Noty({
            text: 'An error occurred',
            theme: 'relax',
            type: 'error',
            layout: 'bottomCenter',
            timeout: 3000,
            progressBar: true
          }).show()
        }
      });
    },
    async setPreCoin({ commit }, params) {
      return await axios.get(`https://api.unminable.com/v5/coin/${params.coin}`).then(function (response) {
        commit('SET_PRE_COIN_SYMBOL', params.coin)
        // commit('SET_PRE_COIN_SYMBOL', response.data.data.symbol)
        commit('SET_PRE_COIN_LOGO', response.data.data.logo)
      }).catch(function (error) {
        console.error('error.response', error.response)
        if (error.response && error.response.status === 404) {
          throw new Error('INVALID');
        } else {
          new Noty({
            text: 'An error occurred',
            theme: 'relax',
            type: 'error',
            layout: 'bottomCenter',
            timeout: 3000,
            progressBar: true
          }).show()
        }
      });
    },
    setCoinCategories ({ commit }, params) {
      commit('SET_COIN_CATEGORIES', params)
    },
    setPageSelected ({ commit }, page) {
      commit('SET_PAGE_SELECTED', page)
    },
    async getCoins ({ commit }) {
      var url = 'https://api.unminable.com/v5/coin'

      return await axios.get(url).then(function (response) {
        let obj = {
          coins: response.data.data
        }

        commit('SET_COINS', obj)
      }).catch(function (error) {
        console.error('error:', error)
        new Noty({
          text        : 'An error occurred',
          theme       : 'relax',
          type        : 'error',
          layout      : 'bottomCenter',
          timeout     : 3000,
          progressBar : true
        }).show()
      });
    },
    async getCoinCategories ({ commit }) {
      var url = 'https://api.unminable.com/v5/coin?categories=1'

      return await axios.get(url).then(function (response) {
        let obj = {
          coinCategories: response.data.data
        }

        commit('SET_COIN_CATEGORIES', obj)
      }).catch(function (error) {
        console.error('error:', error)
        new Noty({
          text        : 'An error occurred',
          theme       : 'relax',
          type        : 'error',
          layout      : 'bottomCenter',
          timeout     : 3000,
          progressBar : true
        }).show()
      });
    },
    async getTiers ({ commit }) {
      var url = `${process.env.API_URL}/v5/referral/info`
      return await axios.get(url).then(function (response) {
        let tiers = response.data.data.tiers

        for (let i = 0; i < tiers.length; i++) {
          const element = tiers[i];
          element.code = +element.code
        }

        let obj = {
          tiers: tiers
        }

        commit('SET_TIERS', obj)
      }).catch(function (error) {
        console.error('error:', error)
        new Noty({
          text        : 'An error occurred',
          theme       : 'relax',
          type        : 'error',
          layout      : 'bottomCenter',
          timeout     : 3000,
          progressBar : true
        }).show()
      });
    },
    notifyWarning({ commit }, message) {
      new Noty({
        text: message || 'An error occurred',
        theme: 'relax',
        type: 'warning',
        layout: 'bottomCenter',
        timeout: 3000,
        progressBar: true
      }).show()
    },
    notifyError ({ commit }, message) {
      new Noty({
        text        : message || 'An error occurred',
        theme       : 'relax',
        type        : 'error',
        layout      : 'bottomCenter',
        timeout     : 3000,
        progressBar : true
      }).show()
    },
    notifySuccess ({ commit }, message) {
      new Noty({
        text        : message || 'Success!',
        theme       : 'relax',
        type        : 'success',
        layout      : 'bottomCenter',
        timeout     : 3000,
        progressBar : true
      }).show()
    },
    setMode ({ commit }, mode) {
      commit('SET_MODE', mode)
    },
    async addToCoinList ({ commit, state }, coin) {
      let lastCoins = state.lastCoins || []

      let foundIndex = lastCoins.findIndex(function (o) { return o === coin })
      if (foundIndex !== -1) lastCoins.splice(foundIndex, 1)

      lastCoins.unshift(coin)

      if (lastCoins.length > 5) lastCoins = lastCoins.slice(0, 5)
      commit('SET_LAST_COINS', lastCoins)
    },
    async addToAlgorithmList ({ commit, state }, algo) {
      let lastAlgorithms = state.lastAlgorithms || []

      let foundIndex = lastAlgorithms.findIndex(function (o) { return o === algo })
      if (foundIndex !== -1) lastAlgorithms.splice(foundIndex, 1)

      lastAlgorithms.unshift(algo)

      if (lastAlgorithms.length > 5) lastAlgorithms = lastAlgorithms.slice(0, 10)
      commit('SET_LAST_ALGORITHMS', lastAlgorithms)
    },
    setShowWarningMessage ({ commit }, param) {
      commit('SET_SHOW_WARNING_MESSAGE', param)
    },
    setWarningMessageTime({ commit }, param) {
      commit('SET_WARNING_MESSAGE_TIME', param)
    },
    setHintSwitchCoinTime({ commit }, param) {
      commit('SET_HINT_SWITCH_COIN_TIME', param)
    },
    async loadBalances({ commit, state }, params) {
      let balancesFrom = [];
      let searchHistory = state.addressHistory;
      for (let i = 0; i < searchHistory.length; i++) {
        for (let j = 0; j < searchHistory[i].addresses.length; j++) {
          if (searchHistory[i].addresses[j].uuid) {
            balancesFrom.push(searchHistory[i].addresses[j].uuid)
          }
        }
      }
      if (balancesFrom.length) {
        return await axios.get(`https://api.unminable.com/v5/accounts/${balancesFrom.join(',')}/balance`).then(function (response) {
          let objFromResponse = {}
          for (let item of response.data.data) {
            objFromResponse[item.uuid] = { balance: item.balance, last: item.last_update }
          }
          let searchHistory = state.addressHistory;
          for (let i = 0; i < searchHistory.length; i++) {
            for (let j = 0; j < searchHistory[i].addresses.length; j++) {
              if (searchHistory[i].addresses[j].uuid && objFromResponse[searchHistory[i].addresses[j].uuid]) {
                searchHistory[i].addresses[j].balance = objFromResponse[searchHistory[i].addresses[j].uuid].balance
                searchHistory[i].addresses[j].last_updated = objFromResponse[searchHistory[i].addresses[j].uuid].last
                searchHistory[i].addresses[j].shouldAnimate = true
                setTimeout(() => {
                  searchHistory[i].addresses[j].shouldAnimate = false
                }, 300);
              }
            }
          }
          commit('SET_ADDRESS_HISTORY', searchHistory)
        }).catch(function (error) {
          console.error('error.response', error.response)
          if (error.response && error.response.status === 404) {
            throw new Error('INVALID');
          } else {
            new Noty({
              text: 'An error occurred',
              theme: 'relax',
              type: 'error',
              layout: 'bottomCenter',
              timeout: 3000,
              progressBar: true
            }).show()
          }
        });
      }
    },
    async addAddressToHistory({ commit, state }, params) {
      let coin = params.coin
      let address = params.address
      let uuid = params.uuid

      let searchHistory = state.addressHistory;
      let newCoin = true;
      let newAddress = true;
      for (let i = 0; i < searchHistory.length; i++) {
        if (searchHistory[i].coin === coin) {
          searchHistory[i].last_viewed = +new Date()
          for (let j = 0; j < searchHistory[i].addresses.length; j++) {
            if (searchHistory[i].addresses[j].address === address) {
              // Edit with last_viewed and uuid
              searchHistory[i].addresses[j].last_viewed = +new Date()
              searchHistory[i].addresses[j].uuid = uuid
              newAddress = false;
            }
          }
          newCoin = false;
        }
      }

      if (newCoin) {
        searchHistory.push({
          coin,
          last_viewed: +new Date(),
          addresses: []
        })
      }

      if (newAddress) {
        for (let i = 0; i < searchHistory.length; i++) {
          if (searchHistory[i].coin === coin) {
            searchHistory[i].addresses.push({
              coin,
              address,
              uuid,
              last_viewed: +new Date()
            })
          }
        }
      }

      // Order everything
      searchHistory = searchHistory.sort((a, b) => b.last_viewed - a.last_viewed);
      for (let i = 0; i < searchHistory.length; i++) {
        searchHistory[i].addresses = searchHistory[i].addresses.sort((a, b) => b.last_viewed - a.last_viewed);
      }

      // Reset the last address per coin
      let lastAddresses = {}
      for (let i = 0; i < searchHistory.length; i++) {
        lastAddresses[searchHistory[i].coin] = searchHistory[i].addresses[0]
      }

      commit('SET_ADDRESS_HISTORY', searchHistory)
      commit('SET_LAST_ADDRESSES', lastAddresses)
    },
    async getLastAddressPerCoin({ commit, state }, coin) {
      return (state.lastAddresses[coin] || {}).address
    },
    async removeAddressFromHistory({ commit, state }, params) {
      let coin = params.coin
      let address = params.address

      let searchHistory = state.addressHistory;
      for (let i = 0; i < searchHistory.length; i++) {
        if (searchHistory[i].coin === coin) {
          searchHistory[i].addresses = searchHistory[i].addresses.filter(function (item) {
            return item.address !== address;
          });
          if (searchHistory[i].addresses.length === 0) {
            // Check history
            let currentCoins = state.lastAddressCoinFilters;
            currentCoins.splice(currentCoins.indexOf(coin), 1)
            commit('SET_LAST_ADDRESSES_COIN_FILTER', currentCoins)
          }
        }
      }

      searchHistory = searchHistory.filter(function (item) {
        return item.addresses.length > 0;
      });

      // Order everything
      searchHistory = searchHistory.sort((a, b) => b.last_viewed - a.last_viewed);
      for (let i = 0; i < searchHistory.length; i++) {
        searchHistory[i].addresses = searchHistory[i].addresses.sort((a, b) => b.last_viewed - a.last_viewed);
      }

      // Reset the last address per coin
      let lastAddresses = {}
      for (let i = 0; i < searchHistory.length; i++) {
        lastAddresses[searchHistory[i].coin] = searchHistory[i].addresses[0]
      }

      commit('SET_ADDRESS_HISTORY', searchHistory)
      commit('SET_LAST_ADDRESSES', lastAddresses)
    },
    async setAddressHistoryBalance({ commit, state }, params) {
      let uuid = params.uuid
      let balance = params.balance
      let lastUpdate = +new Date()

      let searchHistory = state.addressHistory;
      for (let i = 0; i < searchHistory.length; i++) {
        for (let j = 0; j < searchHistory[i].addresses.length; j++) {
          if (searchHistory[i].addresses[j].uuid === uuid) {
            searchHistory[i].addresses[j].balance = balance
            searchHistory[i].addresses[j].last_updated = lastUpdate
            searchHistory[i].addresses[j].shouldAnimate = true
            setTimeout(() => {
              searchHistory[i].addresses[j].shouldAnimate = false
            }, 300);
          }
        }
      }

      commit('SET_ADDRESS_HISTORY', searchHistory)
    },
    shouldShowHint({ commit, state }) {
      let timeToShow = window.dayjs().subtract(15, 'minute').valueOf()
      return state.hintSwitchCoinTime < timeToShow
    },
    getCoin ({ commit, state }) {
      return state.coins
    },
    setChartPeriod({ commit }, params) {
      commit('SET_CHART_PERIOD', params)
    },
    setLogChart({ commit }, params) {
      commit('SET_LOG_CHART', params)
    }
  },
  getters: {
    coin         : (state) => state.coin,
    coinLogo     : (state) => state.coinLogo,
    coinName     : (state) => state.coinName,
    isMemoCoin   : (state) => state.isMemoCoin,
    coins        : (state) => state.coins,
    pageSelected : (state) => state.pageSelected,
    mode         : (state) => state.mode,
    tiers        : (state) => state.tiers,
    addressHistory: (state) => {
      return state.addressHistory.filter(function (item) {
        if (state.lastAddressCoinFilters.length) {
          return state.lastAddressCoinFilters.indexOf(item.coin) > -1;
        } else {
          return true
        }
      });
    },
    lastAddressCoinFilters: (state) => state.lastAddressCoinFilters,
    lastCoins: (state) => state.lastCoins,
    lastAddresses: (state) => state.lastAddresses,
    lastAlgorithms: (state) => state.lastAlgorithms,
    coinSymbol: (state) => state.coinSymbol,
    coinData: (state) => state.coinData,
    coinCategories : (state) => state.coinCategories,
    showWarningMessage : (state) => state.showWarningMessage,
    warningMessageTime : (state) => state.warningMessageTime,
    lastNewsDate : (state) => state.lastNewsDate,
    liveFilter : (state) => state.liveFilter,
    ref : (state) => state.ref,
    showCoinSwitcher : (state) => state.showCoinSwitcher,
    newsCount: (state) => state.newsCount,
    newCoins: (state) => {
      return state.coins.filter(function (item) {
        return item.top === 1 && (state.lastCoins || []).indexOf(item.symbol) === -1
      });
    },
    recentCoins: (state) => {
      let lastCoins = state.lastCoins || []
      let recentCoins = []
      for (let coin of lastCoins) {
        let coinObj = state.coins.find(function (item) {
          return item.symbol === coin
        });
        if (coinObj) recentCoins.push(coinObj)
      }
      return recentCoins
    },
    chartPeriod: (state) => state.chartPeriod,
    logChart: (state) => state.logChart,
    preCoin: (state) => state.preCoin,
    preCoinLogo: (state) => state.preCoinLogo
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/app.js